module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_03-403e5d28e4ab1274f446f8d68a2e4f1f.png";